<template>
  <main class="report">
    <ContentsHeader />
    <article class="main_content" v-show="diagnosisStatus == 0">
      <div class="report_summary">
        <div class="report_summary_wrapper">
          <div class="report_summary__header">
            <div class="report_summary__header_qa" v-on:click="gotoHistory()">回答内容</div>
            <div class="report_summary__header_title">診断結果</div>
          </div>
          <div class="report_summary__info" v-if="page.showLevel == 'high'">
            回答に1つでもマッチした全{{ page?.fitandgaps?.length }}製品のうち、<span style="
                                    font-weight: bold;
                                    color: #ff6b4a;
                                  ">適合度トップ{{ page?.findByLevel("high").length }}</span>をピックアップしました。
          </div>
          <div class="report_summary__info" v-if="page.showLevel == 'middle'">
            回答に1つでもマッチした全{{ page?.fitandgaps?.length }}製品のうち、<span style="
                                    font-weight: bold;
                                    color: #ff6b4a;
                                  ">適合度トップ{{ page?.findByLevel("high").length }}に続く{{
                                    page?.findByLevel("middle").length
                                  }}製品</span>をピックアップしました。
          </div>
          <div class="report_summary__info" v-if="page.showLevel == 'low'">
            回答に1つでもマッチした全{{ page?.fitandgaps?.length }}製品のうち、<span style="
                                    font-weight: bold;
                                    color: #ff6b4a;
                                  ">適合度の低い製品</span>を並べました。
          </div>
          <div class="report_summary__info" v-if="page.showLevel == 'all'">
            回答に1つでもマッチした全{{ page?.fitandgaps?.length }}製品を並べました。
          </div>
          <div class="report_summary__description" v-if="true">
            料金、強み・注意点、市場シェアなどとあわせて、総合的に比較してみましょう。
          </div>
        </div>
      </div>
      <div class="pageselector">
        <div class="pageselector__box">
          <div class="pageselector__label">適合度</div>
          <div class="pageselector__selector" style="border-top-left-radius: 4px"
            :class="[page.showLevel == 'high' ? 'pageselector__selector--selected' : '']"
            v-on:click="page.changeLevel('high')">
            高
            <span style="font-size: 16px" v-if="page.showLevel == 'high'">{{ page?.findByLevel("high").length }}</span>
          </div>
          <div class="pageselector__selector" :class="[
            page.showLevel == 'middle' ? 'pageselector__selector--selected' : '',
          ]" v-on:click="page.changeLevel('middle')">
            中
            <span style="font-size: 16px" v-if="page.showLevel == 'middle'">{{ page?.findByLevel("middle").length
            }}</span>
          </div>
          <div class="pageselector__selector" :class="[page.showLevel == 'low' ? 'pageselector__selector--selected' : '']"
            v-on:click="page.changeLevel('low')">
            低
            <span style="font-size: 16px" v-if="page.showLevel == 'low'">{{ page?.findByLevel("low").length }}</span>
          </div>
          <div class="pageselector__selector" style="border-top-right-radius: 4px"
            :class="[page.showLevel == 'all' ? 'pageselector__selector--selected' : '']"
            v-on:click="page.changeLevel('all')">
            全
            <span style="font-size: 16px">{{ page?.fitandgaps?.length }}</span>
          </div>
        </div>
      </div>
      <div class="fitgapreport_wrapper">
        <div class="fitgapreport" v-if="page.getActives()?.length > 0">
          <table class="fitgapmatrix">
            <thead class="fitgapmatrix__header">
              <tr>
                <th class="pc_menu_line" style="width: 300px; background: #fff">
                  <div style="border-right: 1px solid #eee"></div>
                </th>
                <template v-for="(item, index) in page.getActives()" :key="index">
                  <th style="width: 250px" class="fitgapmatrix__product_title"
                    :class="[index % 2 == 1 ? 'productrecord--step' : '']">

                    <div style="padding: 0 8px">
                      <div style="height: 56px; width: 218px; background: #eee; margin: auto" v-if="false">
                      </div>
                      <img style="height: 56px;width: 218px;object-fit: contain;" src="@/assets/no_image.svg"
                        v-if="!isIcon(item.raw.icon)">
                      <img :src="'icon/' + item.raw.icon" style="height: 56px;width: 218px;object-fit: contain;"
                        v-if="isIcon(item.raw.icon)" />

                      <div style="
                                            font-size: 16px;
                                            font-weight: bold;
                                            line-height: 150%;
                                            text-align: left;
                                            margin-top: 8px;
                                          ">
                        {{ item.getTitle() }}
                      </div>
                      <div style="
                                            font-size: 13px;
                                            line-height: 132%;
                                            text-align: left;
                                            margin-top: 8px;
                                            font-weight: normal;
                                            color: #636464;
                                          ">
                        {{ item.getPlanTitle() }}
                      </div>
                    </div>
                  </th>
                </template>
              </tr>
              <tr>
                <th class="pc_menu_line" style="width: 300px; background: #fff;">
                  <div style="border-right: 1px solid #eee"></div>
                </th>
                <template v-for="(item, index) in page.getActives()" :key="index">
                  <th style="width: 250px" class="fitgapmatrix__product_rate"
                    :class="[index % 2 == 1 ? 'productrecord--step' : '']">
                    <div>
                      <div style="position: relative; height: 8px">
                        <progress style="position: absolute; top: 0; left: 15px" :value="item.getRate()"
                          max="100"></progress>
                      </div>
                      <div style="margin-top: 8px;font-weight: 400;color: #636464;">
                        適合率<span style="
                                              font-size: 32px;
                                              font-weight: bold;
                                              line-height: 120%;
                                              color: rgb(255, 107, 74);
                                            ">{{ item.getRate() }}</span>%
                      </div>
                      <div style="margin-top: 16px;margin-bottom: 16px">
                        <!-- <button class="btn_outline_primary">公式サイトへ <img src="@/assets/open_in_new.svg" /></button> -->
                        <a :href="item.getSiteUrl()" target="_blank" rel="noopener noreferrer" class="btn_outline_primary"
                          style="
                                              display: block;
                                              width: fit-content;
                                              margin: auto;
                                              position: relative;
                                              padding-right: 32px;
                                              text-decoration: none;
                                            ">公式サイトへ
                          <img src="@/assets/open_in_new.svg" style="position: absolute; right: 8px; top: 12px" /></a>
                      </div>
                    </div>
                  </th>
                </template>
              </tr>
            </thead>
            <tbody class="fitgapmatrix__body">
              <template v-for="(axs, rindex) in get1Axes()" :key="rindex">
                <tr class="fitgapmatrix_fitgap_record">
                  <th class="fitgapmatrix_fitgap_record__title pc_menu_line" style="border-bottom: solid 1px #eee" :class="[
                    axs.isExpectation
                      ? 'fitgapmatrix_fitgap_record__title--expections'
                      : '',
                    rindex == 0 ? 'fitgapmatrix_fitgap_record--first' : '',
                  ]">
                    <div
                      style="padding-left: 8px; position: relative; text-align: left; padding-right: 32px;font-weight: 700;font-size: 16px;line-height: 150%;"
                      v-if="axs.isExpectation == true">
                      <img class="axhit" style="position: absolute; right: 8px; top: 3px" src="@/assets/info.svg"
                        v-if="axs.description && axs.description.length > 0"
                        v-on:mouseover="mouseOverAction($event, axs.title, axs.description)"
                        v-on:mouseleave="mouseLeaveAction" />
                      {{ axs.title }}
                    </div>
                    <div style="padding-left: 8px; position: relative; text-align: left; padding-right: 32px;"
                      v-if="axs.isExpectation == false && axs.isCommon == true">
                      <img class="axhit" style="position: absolute; right: 8px; top: 3px" src="@/assets/info.svg"
                        v-if="axs.description && axs.description.length > 0"
                        v-on:mouseover="mouseOverAction($event, axs.title, axs.description)"
                        v-on:mouseleave="mouseLeaveAction" />
                      <span style="font-weight: 700;font-size: 16px;line-height: 150%;">その他</span> <span
                        style="margin-left:8px; font-weight: 400;font-size: 12px;line-height: 126%;">{{ axs.title
                        }}</span>
                    </div>
                    <div
                      style="padding-left: 16px; position: relative; text-align: left; padding-right: 32px; font-weight: 500;font-size: 13px;line-height: 132%;"
                      v-if="axs.isExpectation == false && axs.isCommon == false">
                      <img class="axhit" style="position: absolute; right: 8px; top: 3px" src="@/assets/info.svg"
                        v-if="axs.description && axs.description.length > 0"
                        v-on:mouseover="mouseOverAction($event, axs.title, axs.description)"
                        v-on:mouseleave="mouseLeaveAction" />
                      {{ axs.title }}
                    </div>
                  </th>
                  <template v-for="(item, index) in page.getActives()" :key="index">
                    <td class="fitgapmatrix_fitgap_record__fitgap" :class="[
                      index % 2 == 1 ? 'productrecord--step' : '',

                      rindex == 0 ? 'fitgapmatrix_fitgap_record__fitgap--first' : '',
                    ]">

                      <div class="dummybox">
                        <div
                          style="padding-left: 8px; position: relative; text-align: left; padding-right: 32px;font-weight: 700;font-size: 16px;line-height: 150%;"
                          v-if="axs.isExpectation == true">
                          {{ axs.title }}
                        </div>
                        <div style="padding-left: 8px; position: relative; text-align: left; padding-right: 32px;"
                          v-if="axs.isExpectation == false && axs.isCommon == true">
                          <span style="font-weight: 700;font-size: 16px;line-height: 150%;">その他</span> <span
                            style="margin-left:8px; font-weight: 400;font-size: 12px;line-height: 126%;">{{ axs.title
                            }}</span>
                        </div>
                        <div
                          style="padding-left: 16px; position: relative; text-align: left; padding-right: 32px; font-weight: 500;font-size: 13px;line-height: 132%;"
                          v-if="axs.isExpectation == false && axs.isCommon == false">
                          {{ axs.title }}
                        </div>
                      </div>

                      <div v-if="fitgap2number(item.getEvaluationById(axs.id)) < 0">
                        <img src="@/assets/fitgap_unknown.svg" />
                      </div>
                      <div v-if="fitgap2number(item.getEvaluationById(axs.id)) == 0">
                        <img src="@/assets/fitgap_n.svg" />
                      </div>
                      <div v-if="fitgap2number(item.getEvaluationById(axs.id)) == 1">
                        <img src="@/assets/fitgapfit.svg" />
                      </div>
                      <div style="display: flex;width: 90px;margin: auto;" v-if="false">
                        <img src="@/assets/fitgapfit.svg" />
                        <div style="margin-top: 2px;">追加料金</div>
                      </div>
                      <div v-if="fitgap2number(item.getEvaluationById(axs.id)) == 2">
                        <img src="@/assets/mcond.svg" />
                      </div>
                    </td>
                  </template>
                </tr>
              </template>

              <template v-for="(ppu, pindex) in getPpuses()" :key="pindex">
                <tr class="fitgapmatrix_fitgap_record">
                  <th class="fitgapmatrix_fitgap_record__title fitgapmatrix_fitgap_record__title--expections pc_menu_line"
                    style="border-bottom: solid 1px #eee">
                    <div
                      style="padding-left: 8px; position: relative; text-align: left; padding-right: 32px;font-weight: 700;font-size: 16px;line-height: 150%;">
                      <div>{{ ppu.description }} での利用</div>
                      <div class="payperuse_title dummybox__item">{{ ppu.title }}</div>
                    </div>
                  </th>
                  <template v-for="(item, index) in page.getActives()" :key="index">
                    <td class="fitgapmatrix_fitgap_record__fitgap" :class="[
                      index % 2 == 1 ? 'productrecord--step' : '',

                      rindex == 0 ? 'fitgapmatrix_fitgap_record__fitgap--first' : '',
                    ]">
                      <div class="dummybox">
                        <div
                          style="padding-left: 8px; position: relative; text-align: left; padding-right: 32px;font-weight: 700;font-size: 16px;line-height: 150%;">
                          <div>{{ ppu.description }} での利用</div>
                          <div class="payperuse_title dummybox__item">{{ ppu.title }}</div>
                        </div>
                      </div>
                      <div v-if="fitgap2number(item.getgetPayPerUseById(ppu.id)) < 0">
                        <img src="@/assets/fitgap_unknown.svg" />
                      </div>
                      <div v-if="fitgap2number(item.getgetPayPerUseById(ppu.id)) == 0">
                        <img src="@/assets/fitgap_n.svg" />
                      </div>
                      <div v-if="fitgap2number(item.getgetPayPerUseById(ppu.id)) == 1">
                        <img src="@/assets/fitgapfit.svg" />
                      </div>

                    </td>
                  </template>
                </tr>
              </template>
              <tr>
                <th style="width: 300px; background: #fff" class="pc_menu_line">
                  <div
                    style="width: calc(300px - 16px - 32px); padding-left: 16px; position: relative; text-align: left; padding-right: 32px; font-weight: 500;font-size: 13px;line-height: 132%;">
                    初期費用
                  </div>
                </th>
                <template v-for="(item, index) in page.getActives()" :key="index">
                  <td style="width: 250px" :class="[index % 2 == 1 ? 'productrecord--step' : '']">
                    <div class="dummybox">
                      <div class="dummybox__item"
                        style="padding-left: 16px; text-align: left; padding-right: 32px; font-weight: 500;font-size: 13px;line-height: 132%;">
                        初期費用</div>
                    </div>
                    <div style="width: 218px; padding: 16px">
                      <div v-if="false" style="
                                            font-size: 13px;
                                            line-height: 132%;
                                            text-align: left;
                                            margin-top: 8px;
                                            color: rgb(99, 100, 100);
                                          ">
                        {{ item.getPlanTitle() }}
                      </div>
                      <div style="text-align: center;">
                        <span style="
                                              font-size: 16px;
                                              font-weight: bold;
                                              line-height: 120%;
                                              color: rgb(255, 107, 74);
                                            ">￥{{ item.getInitialCost() }}</span>
                      </div>
                    </div>
                  </td>
                </template>
              </tr>
              <tr>
                <th style="width: 300px; background: #fff" class="pc_menu_line">
                  <div
                    style="width: calc(300px - 16px - 32px); padding-left: 16px; position: relative; text-align: left; padding-right: 32px; font-weight: 500;font-size: 13px;line-height: 132%;">
                    月額
                  </div>
                </th>
                <template v-for="(item, index) in page.getActives()" :key="index">
                  <td style="width: 250px" :class="[index % 2 == 1 ? 'productrecord--step' : '']">
                    <div class="dummybox">
                      <div class="dummybox__item"
                        style="padding-left: 16px; text-align: left; padding-right: 32px; font-weight: 500;font-size: 13px;line-height: 132%;">
                        月額</div>
                    </div>
                    <div style="width: 218px; padding: 16px">
                      <div v-if="false" style="
                                            font-size: 13px;
                                            line-height: 132%;
                                            text-align: left;
                                            margin-top: 8px;
                                            color: rgb(99, 100, 100);
                                          ">
                        {{ item.getPlanTitle() }}
                      </div>
                      <div style="text-align: center;">
                        <span style="
                                              font-size: 16px;
                                              font-weight: bold;
                                              line-height: 120%;
                                              color: rgb(255, 107, 74);
                                            ">￥{{ item.getAllFee() }}～</span>
                      </div>
                      <div class="uchiwakebtn uchiwakebtn--pc" style="text-align: center;">
                        <span v-on:mouseover="uchiwakeMouseOverAction($event, item)"
                          v-on:mouseleave="uchiwakeMouseLeaveAction" style="
                                      font-weight: 400;
                                      font-size: 13px;
                                      line-height: 100%;
                                      text-align: center;
                                      cursor: pointer;
                                      text-decoration-line: underline;
                                      color: #777878;">[内訳]</span>
                      </div>
                      <div class="uchiwakebtn uchiwakebtn--smp" style="text-align: center;">
                        <span v-on:click="smpUchiwakeClick($event, item)" style="
                                      font-weight: 400;
                                      font-size: 13px;
                                      line-height: 100%;
                                      text-align: center;
                                      cursor: pointer;
                                      text-decoration-line: underline;
                                      color: #777878;">[内訳]</span>
                      </div>
                    </div>
                  </td>
                </template>
              </tr>
              <tr v-if="false">
                <th style="width: 300px; background: #fff">
                  <div style="width: 300px; border-right: 1px solid #eee"></div>
                </th>
                <template v-for="(item, index) in page.getActives()" :key="index">
                  <td style="width: 250px" :class="[index % 2 == 1 ? 'productrecord--step' : '']">
                    <div style="width: 218px; padding: 16px; text-align: center">
                      <!-- <button class="btn_outline_primary">公式サイトへ</button> -->
                      <a :href="item.getSiteUrl()" target="_blank" rel="noopener noreferrer" class="btn_outline_primary"
                        style="
                                            display: block;
                                            width: fit-content;
                                            margin: auto;
                                            position: relative;
                                            padding-right: 32px;
                                            text-decoration: none;
                                          ">公式サイトへ
                        <img src="@/assets/open_in_new.svg" style="position: absolute; right: 8px; top: 12px" /></a>
                    </div>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>

        </div>
        <div class="report_footer">
          <div class="report_footer__content">
            <div class="report_footer__description_area">さらに適合度が高い製品を見つけたい場合は、診断に戻り条件を見直してみましょう。</div>
            <div class="report_footer__btn_area report_footer__btn_area--pc" v-on:click="gohome()">
              <a href="javascript:void(0)" rel="noopener noreferrer" class="btn_outline_primary" style="
                                              display: block;
                                              width: fit-content;
                                              position: relative;
                                              padding-left: 32px;
                                              text-decoration: none;
                                            ">診断をやり直す
                <img src="@/assets/undo.svg" style="position: absolute; left: 8px; top: 16px" /></a>
            </div>
            <div class="report_footer__btn_area report_footer__btn_area--smp" v-on:click="gohome()">
              <div class="btn_outline_primary">
                <div style="margin: auto;width: fit-content;padding-left: 30px;position: relative;">
                  <img src="@/assets/undo.svg" style="position: absolute;top: 0;left: 0;" />
                  診断をやり直す
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hheader_shadow"></div>
        <div class="smp_menu_header">
          <table class="fitgapmatrix">
            <thead class="fitgapmatrix__header">
              <tr>
                <template v-for="(item, index) in page.getActives()" :key="index">
                  <th style="width: 250px" class="fitgapmatrix__product_title"
                    :class="[index % 2 == 1 ? 'productrecord--step' : '']">

                    <div style="padding: 0 8px">
                      <img style="opacity: 0; height: 56px;width: 218px;object-fit: contain;" src="@/assets/no_image.svg"
                        v-if="!isIcon(item.raw.icon)">
                      <img :src="'icon/' + item.raw.icon"
                        style="opacity: 0; height: 56px;width: 218px;object-fit: contain;" v-if="isIcon(item.raw.icon)" />

                      <div style="
                                            font-size: 16px;
                                            font-weight: bold;
                                            line-height: 150%;
                                            text-align: left;
                                            margin-top: 8px;
                                            color: rgba(0,0,0,0);
                                          ">
                        {{ item.getTitle() }}
                      </div>
                      <div style="
                                            font-size: 13px;
                                            line-height: 132%;
                                            text-align: left;
                                            margin-top: 8px;
                                            font-weight: normal;
                                            color: rgba(0,0,0,0)
                                          ">
                        {{ item.getPlanTitle() }}
                      </div>
                    </div>
                  </th>
                </template>
              </tr>
              <tr>
                <template v-for="(item, index) in page.getActives()" :key="index">
                  <th style="width: 250px" class="fitgapmatrix__product_rate"
                    :class="[index % 2 == 1 ? 'productrecord--step' : '']">
                    <div>
                      <div style="position: relative; height: 8px">

                      </div>
                      <div style="margin-top: 8px;font-weight: 400;color: rgba(255, 255, 255, 0);">
                        適合率<span style="
                                              font-size: 32px;
                                              font-weight: bold;
                                              line-height: 120%;
                                              color: rgba(255, 255, 255, 0);
                                            ">{{ item.getRate() }}</span>%
                      </div>
                      <div style="margin-top: 16px;margin-bottom: 16px;height: 50px;">

                      </div>
                    </div>
                  </th>
                </template>
              </tr>
            </thead>
            <tbody class="fitgapmatrix__body">
              <template v-for="(axs, rindex) in get1Axes()" :key="rindex">
                <tr class="fitgapmatrix_fitgap_record">
                  <template v-for="(item, index) in page.getActives()" :key="index">
                    <td class="fitgapmatrix_fitgap_record__fitgap" :class="[
                      index % 2 == 1 ? 'productrecord--step' : '',

                      rindex == 0 ? 'fitgapmatrix_fitgap_record__fitgap--first' : '',
                    ]">

                      <div class="">
                        <div
                          style="padding-left: 8px; position: relative; text-align: left; padding-right: 32px;font-weight: 700;font-size: 16px;line-height: 150%;"
                          v-if="axs.isExpectation == true">
                          {{ axs.title }}
                          <img class="" style="position: absolute; right: 8px; top: 3px; pointer-events: all;"
                            src="@/assets/info.svg" v-if="axs.description && axs.description.length > 0"
                            v-on:click.stop="smpinfoclick($event, axs.title, axs.description)" />
                        </div>
                        <div style="padding-left: 8px; position: relative; text-align: left; padding-right: 32px;"
                          v-if="axs.isExpectation == false && axs.isCommon == true">
                          <span style="font-weight: 700;font-size: 16px;line-height: 150%;">その他</span> <span
                            style="margin-left:8px; font-weight: 400;font-size: 12px;line-height: 126%;">{{ axs.title
                            }}</span>
                          <img class="" style="position: absolute; right: 8px; top: 3px; pointer-events: all;"
                            src="@/assets/smpi.svg" v-if="axs.description && axs.description.length > 0"
                            v-on:click.stop="smpinfoclick($event, axs.title, axs.description)" />
                        </div>
                        <div
                          style="padding-left: 16px; position: relative; text-align: left; padding-right: 32px; font-weight: 500;font-size: 13px;line-height: 132%;"
                          v-if="axs.isExpectation == false && axs.isCommon == false">
                          {{ axs.title }}
                          <img class="" style="position: absolute; right: 8px; top: 3px; pointer-events: all;"
                            src="@/assets/smpi.svg" v-if="axs.description && axs.description.length > 0"
                            v-on:click.stop="smpinfoclick($event, axs.title, axs.description)" />
                        </div>
                      </div>

                      <div v-if="fitgap2number(item.getEvaluationById(axs.id)) < 0">
                        <img src="@/assets/fitgap_unknown.svg" style="opacity: 0;" />
                      </div>
                      <div v-if="fitgap2number(item.getEvaluationById(axs.id)) == 0">
                        <img src="@/assets/fitgap_n.svg" style="opacity: 0;" />
                      </div>
                      <div v-if="fitgap2number(item.getEvaluationById(axs.id)) == 1">
                        <img src="@/assets/fitgapfit.svg" style="opacity: 0;" />
                      </div>
                      <div style="display: flex;width: 90px;margin: auto;" v-if="false">
                        <img src="@/assets/fitgapfit.svg" style="opacity: 0;" />
                        <div style="margin-top: 2px;">追加料金</div>
                      </div>
                      <div v-if="fitgap2number(item.getEvaluationById(axs.id)) == 2">
                        <img src="@/assets/mcond.svg" style="opacity: 0;" />
                      </div>
                    </td>
                  </template>
                </tr>
              </template>

              <template v-for="(ppu, pindex) in getPpuses()" :key="pindex">
                <tr class="fitgapmatrix_fitgap_record">
                  <template v-for="(item, index) in page.getActives()" :key="index">
                    <td class="fitgapmatrix_fitgap_record__fitgap" :class="[
                      index % 2 == 1 ? 'productrecord--step' : '',

                      rindex == 0 ? 'fitgapmatrix_fitgap_record__fitgap--first' : '',
                    ]">
                      <div class="">
                        <div
                          style="padding-left: 8px; position: relative; text-align: left; padding-right: 32px;font-weight: 700;font-size: 16px;line-height: 150%;">
                          <div>{{ ppu.description }} での利用</div>
                          <div class="payperuse_title">{{ ppu.title }}</div>
                        </div>
                      </div>
                      <div v-if="fitgap2number(item.getgetPayPerUseById(ppu.id)) < 0">
                        <img src="@/assets/fitgap_unknown.svg" style="opacity: 0;" />
                      </div>
                      <div v-if="fitgap2number(item.getgetPayPerUseById(ppu.id)) == 0">
                        <img src="@/assets/fitgap_n.svg" style="opacity: 0;" />
                      </div>
                      <div v-if="fitgap2number(item.getgetPayPerUseById(ppu.id)) == 1">
                        <img src="@/assets/fitgapfit.svg" style="opacity: 0;" />
                      </div>

                    </td>
                  </template>
                </tr>
              </template>
              <tr>
                <template v-for="(item, index) in page.getActives()" :key="index">
                  <td style="width: 250px" :class="[index % 2 == 1 ? 'productrecord--step' : '']">
                    <div class="">
                      <div class=""
                        style="padding-left: 16px; text-align: left; padding-right: 32px; font-weight: 500;font-size: 13px;line-height: 132%;">
                        初期費用</div>
                    </div>
                    <div style="width: 218px; padding: 16px">
                      <div style="text-align: center;">
                        <span style="
                                              font-size: 16px;
                                              font-weight: bold;
                                              line-height: 120%;
                                              color: rgba(255, 255, 255, 0);
                                            ">￥{{ item.getInitialCost() }}</span>
                      </div>
                    </div>
                  </td>
                </template>
              </tr>
              <tr>
                <template v-for="(item, index) in page.getActives()" :key="index">
                  <td style="width: 250px" :class="[index % 2 == 1 ? 'productrecord--step' : '']">
                    <div class="">
                      <div
                        style="padding-left: 16px; text-align: left; padding-right: 32px; font-weight: 500;font-size: 13px;line-height: 132%;"
                        class="">月額</div>
                    </div>
                    <div style="width: 218px; padding: 16px">
                      <div style="text-align: center;">
                        <span style="
                                              font-size: 16px;
                                              font-weight: bold;
                                              line-height: 120%;
                                              color: rgba(255, 255, 255, 0);
                                            ">￥{{ item.getAllFee() }}～</span>
                      </div>
                      <div style="text-align: center;">
                        <span style="
                                      font-weight: 400;
                                      font-size: 13px;
                                      line-height: 100%;
                                      text-align: center;
                                      cursor: pointer;
                                      text-decoration-line: underline;
                                      color: rgba(255, 255, 255, 0)">[内訳]</span>
                      </div>
                    </div>
                  </td>
                </template>
              </tr>

            </tbody>
          </table>


        </div>
      </div>
    </article>
    <div style="margin-top: 0px; margin-bottom: 0px; background: #eff0f0" v-if="pager.isDebug">
      <div>デバグ</div>
      <div>
        製品評価軸：
        {{ getAxes() }}
      </div>

      <table>
        <tbody>
          <tr>
            <th>ID</th>
            <th>製品タイトル</th>
            <th>製品プラン名</th>
            <th>適合率</th>
            <th>適合区分</th>
            <th>月額</th>
            <th>サイトURL</th>
          </tr>
          <template v-for="(item, index) in page.getActives()" :key="index">
            <tr>
              <td>{{ item.getId() }}</td>
              <td>{{ item.getTitle() }}</td>
              <td>{{ item.getPlanTitle() }}</td>
              <td>{{ item.getRate() }}</td>
              <td>{{ item.getRank() }}</td>
              <td>{{ item.getFee() }}</td>
              <td>{{ item.getSiteUrl() }}</td>
            </tr>
          </template>
        </tbody>
      </table>
      <div>
        {{ page.getActives() }}
      </div>
      <div>評価軸</div>
      <div>
        {{ getAxes() }}
      </div>
    </div>
    <div class="hint_area" :style="{ top: `${hoverY()}px`, left: `${hoverX()}px` }">
      <div class="hint_box" v-if="hint != null">
        <div class="hint_box__title">
          対応機能：<span style="font-weight: 600">{{ hint.title }}</span>
        </div>
        <div class="hint_box__description">{{ hint.description }}</div>
      </div>
    </div>
    <div class="hint_area" :style="{ top: `${uchiwakeHoverY()}px`, left: `${uchiwakeHoverX()}px` }">
      <div class="hint_box" v-if="uchiwake != null">
        <div class="hint_box__title"
          style="font-weight: 700;font-size: 14px;line-height: 142%;color: #444545; margin-bottom: 12px">
          月額料金の内訳
        </div>
        <div style="font-weight: 400;font-size: 14px;line-height: 142%;color: #636464;">固定：基本料金<span
            style="font-weight: 700;font-size: 16px;line-height: 120%;color: #FF6B4A;">￥{{
              uchiwake.item.getFee().toLocaleString() }}</span>
        </div>
        <template v-for="(item, index) in uchiwake.item.getPayPerUses()" :key="index">
          <div style="padding-left: 16px">+</div>
          <div style="font-weight: 400;font-size: 14px;line-height: 142%;color: #636464;">従量:{{ item.title }} <span
              style="font-weight: 700;font-size: 16px;line-height: 120%;color: #FF6B4A;">￥{{
                Number(item.fee).toLocaleString() }}</span></div>
        </template>
      </div>
    </div>

    <div class="smp_info_dialog" v-if="(smphit1 != null) || (smpuchiwake != null)">
      <div class="smp_info_dialog__background"></div>
      <div class="smp_info_dialog__message">
        <div class="smp_info_dialog__message_area">
          <div class="smp_info_dialog__box" v-if="smphit1 != null">
            <div style="position: relative;">
              <div style="position: absolute; right: 0; top: 0"><img class="smp_dialog_close_icon"
                  src="@/assets/close.svg" v-on:click="smphintclose()" /></div>
            </div>
            <div style="width: calc(100% - 34px);">対応機能：<span style="font-weight: 600">{{ smphit1.title }}</span></div>
            <div style="margin-top: 8px;">{{ smphit1.description }}</div>
          </div>
          <div class="smp_info_dialog__box" v-if="smpuchiwake != null">
            <div style="position: relative;">
              <div style="position: absolute; right: 0; top: 0"><img class="smp_dialog_close_icon"
                  src="@/assets/close.svg" v-on:click="smphintclose()" /></div>
            </div>
            <div class="hint_box__title"
              style="font-weight: 700;font-size: 14px;line-height: 142%;color: #444545; margin-bottom: 12px">
              月額料金の内訳
            </div>
            <div style="font-weight: 400;font-size: 14px;line-height: 142%;color: #636464;">固定：基本料金<span
                style="font-weight: 700;font-size: 16px;line-height: 120%;color: #FF6B4A;">￥{{
                  smpuchiwake.item.getFee().toLocaleString() }}</span>
            </div>
            <template v-for="(item, index) in smpuchiwake.item.getPayPerUses()" :key="index">
              <div style="padding-left: 16px">+</div>
              <div style="font-weight: 400;font-size: 14px;line-height: 142%;color: #636464;">従量:{{ item.title }} <span
                  style="font-weight: 700;font-size: 16px;line-height: 120%;color: #FF6B4A;">￥{{
                    Number(item.fee).toLocaleString() }}</span></div>
            </template>

          </div>
        </div>
      </div>
    </div>

    <ContentsFooter :pager="pager" />


    <div class="diagnloading" v-if="diagnosisStatus > 0">
      <div class="diagnloading__box">
        <div class="diagnloading__mark">
          <div id="lottie"></div>
        </div>
        <div class="diagnloading__title" v-if="diagnosisStatus == 1">結果を作成中...</div>
        <div class="diagnloading__title" v-if="diagnosisStatus == 2">あなたの診断結果が準備できました</div>
        <div class="diagnloading__btn" v-if="diagnosisStatus == 2"><button class="btn_primary" style="width: 100%"
            v-on:click="show()">診断結果を見る</button></div>
      </div>

    </div>

    <div class="contact_us_layer" v-if="idfloatcontactus">
      <div class="contact_us" v-on:click="contactus">
        <div class="contact_us__icon"><img width="24" height="24" src="@/assets/message.svg" /></div>
        <div class="contact_us__title">ご意見・ご要望</div>
      </div>
    </div>
  </main>
</template>

<style scoped>
.smp_info_dialog__background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.24);
  z-index: 10;
}

.smp_info_dialog__message {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 255, 0, 0);
  z-index: 11;
}

.smp_info_dialog__message_area {
  padding: 12px;
}

.smp_info_dialog__box {
  width: initial;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.24);
  padding: 12px;
  z-index: 10;
  border-radius: 4px;
  background: #fff;
}
</style>

<style scoped>
.contact_us_layer {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 3;
}

.contact_us {
  padding: 13px;
  display: flex;
  box-shadow: 0px 0px 2px 0px #0000003D;
  position: relative;
  border-radius: 20px;
  background: white;
  z-index: 3;
  cursor: pointer;
}

.contact_us:hover {
  border: 1px solid #444545;
}

.contact_us__icon {
  position: absolute;
  top: 10px;
}

.contact_us__title {
  font-family: Noto Sans JP;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: center;
  margin-left: 35px;
}

.dummybox {
  display: none;
}


.report_footer__btn_area--smp {
  display: none;
}
</style>

<style scoped>
.payperuse_title {
  font-weight: 400;
  font-size: 13px;
  line-height: 132%;
  color: #636464;
}
</style>

<style scoped>
.axistitle {
  padding-left: 8px;
}

.axistitle--axis {
  padding-left: 16px;
}
</style>

<style scoped>
.report {
  min-height: 100vh;
  flex-flow: column;
  display: flex;
}

.main_content {
  flex: 1;
}
</style>

<style scoped>
.axhit {
  cursor: pointer;
}

.report_summary__header_title {
  margin: auto;
  width: 80px;
}

.report_summary__header_qa {
  position: absolute;
  font-size: 14px;
  line-height: 100%;
  font-weight: 400;
  top: 8px;
  left: 16px;
  color: #00AEAA;
  cursor: pointer;
}

.report_summary__header_qa:hover {
  color: #00C9C9;
}

.report_footer {
  height: calc(128px - 24px);
}

.report_footer__content {
  display: flex;
  width: fit-content;
  margin: auto;
  margin-top: 24px;
}

.report_footer__description_area {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #444545;
  margin-right: 4px;
  margin-top: 12px;
}

.fitgapreport_wrapper {
  position: relative;
}

.hheader_shadow {
  position: absolute;
  top: 0px;
  z-index: 10;
  left: 0;
  bottom: 144px;
  width: 300px;
  box-shadow: 2px 0px 2px rgba(0, 0, 0, 0.24);
  pointer-events: none;
}

.pc_menu_line {}

.smp_menu_header {
  display: none;
}

.smp_menu_header .fitgapmatrix_fitgap_record {
  background: rgba(255, 255, 255, 0);
}

.uchiwake {}

.uchiwakebtn--smp {
  display: none;
}
</style>

<style scoped>
.hint_area {
  position: absolute;
  z-index: 10;
}

.hint_box {
  width: 300px;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.24);
  padding: 12px;
  z-index: 10;
  border-radius: 4px;
  background: #fff;
}
</style>

<style scoped>
.diagnloading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 100;
}

.diagnloading__box {
  width: 320px;
  margin: auto;
  margin-top: 200px;
}

.diagnloading__title {
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
}

.diagnloading__title {
  font-size: 14px;
  line-height: 142%;
  color: #00AEAA;
}

#lottie {
  margin: auto;
  width: 150px;
}
</style>

<style>
@media (min-width: 599px) {

  /* CSS rules here */
  .fitgapmatrix {
    /* 縦スクロール時に固定する */
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    /* tbody内のセルより手前に表示する */
    z-index: 1;
  }

  .fitgapmatrix th:first-child {
    /* 横スクロール時に固定する */
    position: -webkit-sticky;
    position: sticky;
    left: 0;
  }

  .fitgapmatrix th:first-child {
    /* ヘッダー行内の他のセルより手前に表示する */
    z-index: 2;
  }
}

.fitgapmatrix__product_title {
  vertical-align: top;
  width: 250px;
  padding-top: 16px;
}

.fitgapmatrix__product_rate {
  vertical-align: top;
}

.fitgapmatrix_fitgap_record {
  height: 44px;
  background: #fff;
}

.fitgapmatrix_fitgap_record__fitgap {
  text-align: center;
  border-bottom: solid 1px #eee;
  font-size: 13px;
  color: #636464;
}

.fitgapmatrix_fitgap_record--first {
  border-top: solid 1px #eee;
}

.fitgapmatrix_fitgap_record__fitgap--first {
  border-top: solid 1px #eee;
}

.fitgapmatrix_fitgap_record__title {
  background: #fff;
}

.fitgapmatrix_fitgap_record__title--expections {
  background: rgb(249, 251, 251);
}
</style>

<style scoped>
progress {
  width: 220px;
  height: 4px;
  border-radius: 2px;
}

progress::-webkit-progress-bar {
  background-color: #e2e3e3;
  border-radius: 15px;
}

progress::-webkit-progress-value {
  background: rgb(255, 107, 74);
  border-radius: 15px;
}

progress::-moz-progress-bar {
  border-radius: 15px;
  background-color: #e2e3e3;
}

progress::-ms-fill {
  background: rgb(255, 107, 74);
  border-radius: 15px;
}
</style>

<style scoped>
.productrecord--step {
  background: #f9fbfb;
}

.fitgapreport {
  overflow: auto;
  background: #fff;
  position: relative;
}
</style>

<style scoped>
.pageselector__label {
  width: 64px;
  padding-top: 10px;
  font-size: 16px;
}

.pageselector {
  margin-top: 12px;
  border-bottom: 2px solid #00aeaa;
}

.pageselector__selector {
  width: 64px;
  text-align: center;
  border: 1px solid #00aeaa;
  color: #00AEAA;
  font-size: 20px;
  cursor: pointer;
  padding-top: 10px;
}

.pageselector__selector:hover {
  color: #00C9C9;
}

.pageselector__selector--selected {
  width: 218px;
  background: #00aeaa;
  color: #fff;
}

.pageselector__selector--selected:hover {
  color: #fff;
}

.pageselector__box {
  display: flex;
  max-width: 480px;
  margin: auto;
  height: 48px;
}

.report_summary {
  /* width: fit-content; */
  padding: 8px;
  margin: auto;
  margin-top: 24px;
}

@media all and (min-width:900px) {

  /* CSS rules here */
  .report_summary {
    width: 860px;
  }
}

.report_summary_wrapper {
  padding: 12px;
  border-radius: 4px;

  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.24);
}

.report_summary__header {
  font-size: 20px;
  font-weight: bold;
  line-height: 150%;
  position: relative;
}

.report_summary__info {
  font-size: 20px;
  line-height: 150%;
  padding: 23px 12px;
  background: #feeebb;
  border-radius: 4px;
  margin-top: 8px;
  margin-bottom: 8px;
}

.report_summary__description {
  font-size: 16px;
  line-height: 150%;
  color: #636464;
}
</style>

<style scoped>
@media (max-width:598px) {

  /* CSS rules here */
  .report_footer {
    padding: 18px;
  }

  .report_footer__content {
    display: block;
    margin-top: 0;
  }

  .report_footer__description_area {
    margin-top: 0;
    margin-bottom: 16px;
    font-size: 13px;
  }

  .report_summary {
    margin-top: 8px;
  }

  .report_summary__info {
    font-size: 14px;
    padding: 8px;
  }

  .report_summary__description {
    font-size: 13px;
  }

  .pageselector {
    padding-left: 8px;
    padding-right: 8px;
  }

  .pageselector__label {
    font-size: 13px;
    padding-top: 16px;
  }

  .hheader_shadow {
    display: none;
  }

  .pc_menu_line {
    display: none;
  }

  .dummybox {
    display: block;
    color: rgba(0, 0, 0, 0);
  }

  .dummybox__item {
    color: rgba(0, 0, 0, 0);
  }

  .smp_menu_header {
    display: block;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 10;
    width: 250px;
    overflow: hidden;
    pointer-events: none;
  }

  .uchiwakebtn--pc {
    display: none;
  }

  .uchiwakebtn--smp {
    display: block;
  }

  .report_footer__btn_area a {
    width: 100%;
  }

  .report_footer__btn_area--pc {
    display: none;
  }

  .report_footer__btn_area--smp {
    display: block;
  }

  @media all and (min-width:376px) and (max-width:598px) {}
}

@media (min-width:599px) and (max-width:1022px) {
  /* CSS rules here */

}

@media (min-width:1023px) and (max-width:1918px) {
  /* CSS rules here */

}

@media all and (min-width:1919px) {
  /* CSS rules here */

}
</style>

<script>
// @ is an alias to /src

/* global bodymovin */

import tacklebox from "tacklebox";
import ContentsHeader from "@/components/ContentsHeader.vue";
import ContentsFooter from "@/components/ContentsFooter.vue";

import { ReportPage } from "@/js/page/ReportPage.js";

function Hint(title, description, x, y) {
  this.title = title;
  this.description = description;
  this.x = x;
  this.y = y;
}
function Uchiwake(item, x, y) {
  this.item = item;
  this.x = x;
  this.y = y;
}

export default {
  name: "ReportView",
  data() {
    return {
      page: new ReportPage(),
      hint: null,
      uchiwake: null,
      diagnosisStatus: 1,
      idfloatcontactus: false,
      smphit1: null,
      smpuchiwake: null,
    };
  },
  watch: {
    "page.isloaded": function (newv, oldv) {
      if (oldv || newv) {
        //
      }
      const self = this;
      if (newv) {
        setTimeout(function () {
          self.diagnosisStatus = 0;
        }, 1000 * 2);
      }
    }
  },
  mounted() {
    this.page.interviewId = this.$route.params.id;
    this.pager.changePage(this.page);
    bodymovin.loadAnimation({
      container: document.getElementById('lottie'),
      renderer: 'svg', // 描画形式
      loop: false, // trueにしたらループ。1回再生の場合はfalse
      autoplay: true, // 自動再生
      path: 'loading.json', // jsonのパスを指定
      name: "Hello World", // 今後のリファレンスとして名前を指定（オプション）
    });
    // const self = this;
    // setTimeout(function () {
    //   self.diagnosisStatus = 0;
    // }, 1000 * 6);

    document.title = "FitGap | 自社にぴったりのサービスを選ぶための無料診断 ";

    window.addEventListener("scroll", this.getScroll)
  },
  beforeUnmount() {
    //
    tacklebox.d("unmount");
    window.removeEventListener("scroll", this.getScroll)

  },
  methods: {
    smphintclose() {
      this.smphit1 = null;
      this.smpuchiwake = null;
    },
    gohome() {
      this.$router.push("/");
    },
    smpUchiwakeClick(e, item) {
      if (e) {
        //
      }
      console.log(item);

      this.smpuchiwake = new Uchiwake(item, 0, 0);
    },
    smpinfoclick(e, title, description) {
      if (e) {
        //
      }
      console.log(title, description);
      this.smphit1 = {
        title: title,
        description: description
      };
    },
    getScroll() {
      if (document.body.clientHeight - (window.innerHeight + window.scrollY) < 60) {
        this.idfloatcontactus = false;
      } else {
        this.idfloatcontactus = true;
      }
    },
    contactus() {
      window.open('https://docs.google.com/forms/d/e/1FAIpQLScK7dLugUzQ8gQ9BPXCLqvN23xEjrTJ2EdfJ5ySr9OBS3KGGQ/viewform', '_blank');
    },
    gotoHistory() {
      this.$router.push({ name: "history" });
    },
    show() {
      this.diagnosisStatus = 0;
    },
    isIcon(icon) {
      if (icon) {
        if (icon.length > 0) {
          return true;
        }
      }
      return false
    },
    hoverX() {
      if (this.hint) {
        return this.hint.x;
      }
      return 0;
    },
    hoverY() {
      if (this.hint) {
        return this.hint.y;
      }
      return 0;
    },
    mouseOverAction(e, title, description) {
      this.hint = new Hint(title, description, e.pageX + 30, e.pageY);
    },
    mouseLeaveAction() {
      this.hint = null;
    },
    uchiwakeHoverX() {
      if (this.uchiwake) {
        return this.uchiwake.x;
      }
      return 0;
    },
    uchiwakeHoverY() {
      if (this.uchiwake) {
        return this.uchiwake.y;
      }
      return 0;
    },
    uchiwakeMouseOverAction(e, item) {
      if (item) {
        //
      }
      this.uchiwake = new Uchiwake(item, e.pageX - 330, e.pageY - 160);
    },
    uchiwakeMouseLeaveAction() {
      this.uchiwake = null;
    },
    fitgap2number(fitgap) {
      switch (fitgap) {
        case "gap":
          return 0;
        case "fit":
          return 1;
        case "cfit":
          return 2;
      }

      return -1;
    },
    getAxes() {
      let axs = [];
      let acs = this.page.getActives();
      if (acs) {
        if (acs.length > 0) {
          let evs = acs[0].getEvaluations();
          if (evs) {
            for (let j in evs) {
              let fgs = evs[j].fitandgaps;
              if (fgs) {
                for (let x in fgs) {
                  axs.push(fgs[x].title);
                }
              }
            }
          }
        }
      }
      return axs;
    },
    get1Axes() {
      let axs = [];
      let acs = this.page.getActives();
      if (acs) {
        if (acs.length > 0) {
          let evs = acs[0].getEvaluations();
          if (evs) {
            for (let j in evs) {
              let fgs = evs[j].fitandgaps;
              if (evs[j].title != "共通") {
                axs.push({
                  id: evs[j].id,
                  title: evs[j].title,
                  description: "",
                  isExpectation: true,
                  isCommon: false,
                });
              }

              if (fgs) {
                for (let x in fgs) {
                  let isHit = false;
                  for (let y in axs) {
                    if (axs[y].id == fgs[x].id) {
                      isHit = true;
                    }
                  }
                  if (!isHit) {
                    let isCommon = false;
                    for (let q in evs) {
                      if (evs[q].title == '共通') {
                        for (let p in evs[q].fitandgaps) {
                          if (fgs[x].id == evs[q].fitandgaps[p].id) {
                            isCommon = true;
                            break;
                          }
                        }
                      }
                      if (isCommon) {
                        break;
                      }
                    }
                    axs.push({
                      id: fgs[x].id,
                      title: fgs[x].title,
                      description: fgs[x].description,
                      isExpectation: false,
                      isCommon: isCommon,
                    });
                  }
                }
              }
            }
          }
        }
      }
      return axs;
    },
    getPpuses() {
      let rppus = [];
      let targets = this.page.getActives();
      if (targets) {
        if (targets.length > 0) {
          let ppus = targets[0].getPayPerUses();
          for (let i in ppus) {
            rppus.push({
              "id": ppus[i].id,
              "title": ppus[i].title,
              "description": ppus[i].description
            });


          }
        }
      }
      return rppus;
    }
  },
  components: {
    ContentsFooter,
    ContentsHeader,
  },
  props: {
    pager: Object,
  },
};
</script>
